<template>
  <base-material-card
    :icon="org ? 'mdi-office-building-cog' : 'mdi-cursor-pointer'"
    :title="org ? org.nome : 'Organização'"
    color="secondary"
    class="flex-grow-1 d-flex flex-column"
  >
    <template
      v-if="org"
      #after-heading-default
    >
      <v-chip
        :color="org.habilitado ? 'success' : 'grey'"
        x-small
        dark
        class="ml-2"
      >
        {{ org.habilitado ? 'Ativa' : 'Desativada' }}
      </v-chip>
    </template>

    <div
      v-if="!org"
      class="grey--text text--darken-1 pa-8 text-center"
    >
      <v-icon
        x-large
        color="grey lighten-1"
        class="mb-2"
      >
        mdi-gesture-tap
      </v-icon>
      <div class="text-h6 font-weight-light">
        Selecione uma organização à esquerda
      </div>
      <div class="text-body-2 mt-1">
        Detalhes, usuários, configurações, dicionários, assinaturas e permissões aparecerão aqui.
      </div>
    </div>

    <template v-else>
      <v-tabs
        v-model="activeTab"
        background-color="transparent"
        color="secondary"
        show-arrows
        class="mb-3"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.key"
        >
          <v-icon
            small
            class="mr-1"
          >
            {{ tab.icon }}
          </v-icon>
          {{ tab.label }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        class="transparent"
      >
        <v-tab-item
          v-for="tab in tabs"
          :key="tab.key"
        >
          <component
            :is="tab.component"
            v-if="loadedTabs[tab.key]"
            :org="org"
          />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </base-material-card>
</template>

<script>
  import OverviewTab from './tabs/OverviewTab.vue'
  import UsersTab from './tabs/UsersTab.vue'
  import SettingsTab from './tabs/SettingsTab.vue'
  import DictionaryTab from './tabs/DictionaryTab.vue'
  import SubscriptionsTab from './tabs/SubscriptionsTab.vue'
  import RolesTab from './tabs/RolesTab.vue'

  const TABS = [
    { key: 'overview', label: 'Visão geral', icon: 'mdi-view-dashboard-outline', component: 'OverviewTab' },
    { key: 'users', label: 'Usuários', icon: 'mdi-account-multiple', component: 'UsersTab' },
    { key: 'settings', label: 'Configurações', icon: 'mdi-cog-outline', component: 'SettingsTab' },
    { key: 'dictionary', label: 'Dicionários', icon: 'mdi-book-alphabet', component: 'DictionaryTab' },
    { key: 'subscriptions', label: 'Assinaturas', icon: 'mdi-card-account-details-outline', component: 'SubscriptionsTab' },
    { key: 'roles', label: 'Cargos & Permissões', icon: 'mdi-shield-key-outline', component: 'RolesTab' },
  ]

  export default {
    name: 'OrganizationPanel',

    components: {
      OverviewTab,
      UsersTab,
      SettingsTab,
      DictionaryTab,
      SubscriptionsTab,
      RolesTab,
    },

    props: {
      org: { type: Object, default: null },
    },

    data: () => ({
      activeTab: 0,
      tabs: TABS,
      // Lazy mount tab contents only after they are first opened
      loadedTabs: { overview: true },
    }),

    watch: {
      activeTab (idx) {
        const key = this.tabs[idx]?.key
        if (key) this.$set(this.loadedTabs, key, true)
      },
      org () {
        // Reset to overview when switching org
        this.activeTab = 0
        this.loadedTabs = { overview: true }
      },
    },
  }
</script>
